import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    disabled: "",
    selected: "",
    value: ""
};
const _hoisted_2 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _withDirectives((_openBlock(), _createElementBlock("select", {
        class: "AtSelectNative",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedItem) = $event))
    }, [
        (_ctx.labelOption)
            ? (_openBlock(), _createElementBlock("option", _hoisted_1, _toDisplayString(_ctx.labelOption), 1))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("option", {
                key: option.value,
                value: option.value
            }, _toDisplayString(option.text), 9, _hoisted_2));
        }), 128))
    ], 512)), [
        [_vModelSelect, _ctx.selectedItem]
    ]);
}
